<template>
  <div>
    <cat-date-range
      v-for="(date, index) in locationDates"
      :key="index"
      :index="index"
      :location-date="date"
      :is-editing="currentlyEditingId === index"
      @update-editing="(id) => emit('date-change', id)"
      @cancel-update="cancelUpdate(index)"
    />
    <kudo-card
      class="border border-solid border-gray-light shadow-none mt-4"
    >
      <kudo-block>
        <kudo-button
          type="button"
          shape-variant="thin"
          class="w-auto self-start hover:bg-transparent disabled:text-gray"
          color-variant="flat"
          :disabled="currentlyEditingId !== null"
          data-cypress="dates-and-states-add-button"
          @click="addNewDateRange"
        >
          <i class="fas fa-plus" />
          Add Date Range
        </kudo-button>
      </kudo-block>
    </kudo-card>
    <p
      v-for="(error, index) in $vuelidateErrorsToStrings(locationDatesErrors)"
      :key="index"
      class="mt-3 text-xs text-red"
    >
      {{ error }}
    </p>
  </div>
</template>

<script setup>
import { KudoButton, KudoCard, KudoBlock } from '@openly-engineering/kudo'
import { DATES_AND_STATES_STEP_PATH, OVERVIEW_STEP_PATH } from './cat-tag-utils'
import CatDateRange from '~/components/claims-admin/cat-date-range.vue'
const { v$ } = useCatTagValidation()

const { $store, $vuelidateErrorsToStrings } = useNuxtApp()
const emit = defineEmits(['change-date'])

const props = defineProps({
  currentlyEditingId: {
    type: Number || null,
    required: true,
  },
})

const locationDates = computed(() => { return $store.state.adminClaims[DATES_AND_STATES_STEP_PATH].formData.locationDates })
const catType = computed(() => { return $store.state.adminClaims[OVERVIEW_STEP_PATH].formData.type })
const locationDatesErrors = computed(() => v$.value[DATES_AND_STATES_STEP_PATH].locationDates.$errors.filter(error => error.$validator !== '$each'))

// Used to revert the previous state when the user edits an existing locationDate but then hits "cancel". We save a static version of the locationDate as soon as we enter edit mode, hence it is the "cached" data
let cachedLocationDate = {}

// Watch props.currentlyEditingId - when a new locationDate is edited, save state to "cache" so we can revert it if needed
watch(() => props.currentlyEditingId, (newVal, oldVal) => {
  if (oldVal === null && newVal !== null) {
    cachedLocationDate = { ...locationDates.value[props.currentlyEditingId] }
  }
})

function cancelUpdate(index) {
  if (!locationDates.value[index].saved) {
    // If the locationDate being edited hasn't been saved, delete this locationDate entirely
    $store.commit('adminClaims/removeLocationDate', index)
  } else {
    // Revert the changes by updating the location date with the cache data
    $store.commit('adminClaims/updateLocationDate', { locationDate: cachedLocationDate, index: props.currentlyEditingId })
  }
  emit('date-change', null)
  cachedLocationDate = {}
}

defineExpose({
  cancelUpdate,
})

function addNewDateRange() {
  $store.commit('adminClaims/addLocationDate', {
    states: [],
    type: catType.value,
    startDate: '',
    endDate: '',
    saved: false, // this value lets us know if a locationDate is newly-created and hasn't been saved yet
  })
  emit('date-change', locationDates.value.length - 1)
}
</script>
